import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PreorderService from "./preorder-service";
import Col from "../../components/tailwind/col";
import { useTranslation } from "react-i18next";
import ServiceDetails from "./service-details";
import AppLink from "../router/app-link";
import Button from "../tailwind/button";
import { convertDate } from "../../functions";


export interface IFileDetailsProps {
  status: {
    code: number;
    title: string;
  };
  activeService?: {
    resetTrafficDateTime?: Date;
    serviceTitle: string;
    endDateTime: Date;
  };
  preOrderedServiceTitle?: string;
  hasNoRemindTraffic: boolean;
  onActivateNextService: () => void;
  link: string;
  ipService?: {
    value: string;
    endDateTime: Date;
    startDateTime: Date;
  };}

export default function FileDetails({
  status,
  activeService,
  preOrderedServiceTitle,
  hasNoRemindTraffic,
  onActivateNextService,
  link,
  ipService,
}: IFileDetailsProps) {
  const { t } = useTranslation();

  const renderLink = (link: string) => {
    switch (link) {
      case "up":
        return <FontAwesomeIcon icon="link" className="text-success" />;
      case "down":
        return <FontAwesomeIcon icon="unlink" className="text-danger" />;
      default:
        return null;
    }
  };

  const renderBattery = (fileStatus: string | number) => {
    switch (fileStatus) {
      case 10:
      case "Active":
        return <FontAwesomeIcon icon="battery-full" className="text-success" />;
      case 11:
      case "Suspended":
        return <FontAwesomeIcon icon="battery-half" className="text-warning" />;
      default:
        return (
          <FontAwesomeIcon icon="battery-empty" className="text-secondary" />
        );
    }
  };

  let shouldShowServiceRows = [1, 11].includes(status.code);
  let showFullServiceDetails = status.code === 10;

  return (
    <Col className="col-sm-6 col-xs-12 mb-3 mb-sm-0">
      <div className="bgc-white radius-1" style={{ minWidth: "100%" }}>
        <div className="default table table-striped table-borderless">
          <tbody>
            <tr />
            <tr>
              <td>{renderBattery(status.code)}</td>
              <td className="text-95 text-600 text-secondary-d2">
                وضعیت پرونده
              </td>
              <td className="text-dark-m3">
                <span>{status.title + " "}</span>
                {renderLink(link)}
              </td>
            </tr>

            {showFullServiceDetails && (
              <>
                <ServiceDetails activeService={activeService} />
                <tr>
                  <td>
                    <FontAwesomeIcon
                      icon="step-forward"
                      className="text-blue-d3"
                    />
                  </td>
                  <td className="text-95 text-600 text-secondary-d2">
                    سرویس بعدی
                  </td>
                  <td className="text-dark-m3">
                    <PreorderService
                      preOrderedServiceTitle={preOrderedServiceTitle}
                      hasNoRemindTraffic={hasNoRemindTraffic}
                      onActivate={onActivateNextService}
                      statusCode={status.code}
                    />
                  </td>
                </tr>
              </>
            )}

            {shouldShowServiceRows && (
              <>
                {activeService ? (
                  <ServiceDetails activeService={activeService} />
                ) : (
                  <tr>
                    <td></td>
                    <td className="text-95 text-600 text-secondary-d2">
                      سرویس جاری
                    </td>
                    <td className="text-dark-m3">
                      <Button className="mx-0 btn-xs btn-primary">
                        <AppLink to="/purchase/service">
                          {t("Dashboard.PreorderService.PurchaseService")}
                        </AppLink>
                      </Button>
                    </td>
                  </tr>
                )}
              </>
            )}
            {ipService?.value && (
              <tr>
                <td>
                  <FontAwesomeIcon icon="tags" className="text-danger" />
                </td>
                <td className="text-95 text-600 text-secondary-d2">
                  آی پی ثابت
                </td>
                <td className="text-dark-m3">
                  <span>{ipService?.value} </span>
                </td>
              </tr>
            )}
            {ipService?.startDateTime && (
              <tr>
                <td>
                  <FontAwesomeIcon icon="tags" className="text-danger" />
                </td>
                <td className="text-95 text-600 text-secondary-d2">
                  تاریخ پایان سرویس آی پی
                </td>
                <td className="text-dark-m3">
                  <span>{convertDate(ipService?.endDateTime)}</span>
                </td>
              </tr>
            )}
          </tbody>
        </div>
      </div>
    </Col>
  );
}
